import React from 'react'
import { Flex, layout, styled, Span } from '@fareye/ui'
import { getValueFromNestedKey } from '@fareye/utils'
import { terminalView } from '@fareye/configs'
import { FaArrowRight } from '@fareye/utils'
import { ColFullHeight } from '../../../../style/styled'
import { formatters } from '../../../../config/constants'

const CustomColFullHeight: any = styled(Span)`
  white-space: nowrap;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  line-height: 24px;
  font-family: Roboto;
  font-style: normal;
  font-size: 16px;
  padding: 4px 12px;
  color: ${terminalView.darkTheme.textColor};
  @media (min-width: 1920px) and (max-width: 3840px) {
    line-height: 32px;
    font-size: 20px;
  }
  @media (min-width: 3840px) {
    line-height: 44px;
    font-weight: 600;
    font-size: 44px;
    padding: 24px 24px;
  }
`
const ColHeader: any = styled(Flex)`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  font-family: Roboto;
  font-style: normal;
  color: ${terminalView.darkTheme.textColor};
  border-right: hidden;
  margin: auto 16px;
  align-items: center;
  height: 38px;
  @media (min-width: 1920px) and (max-width: 3840px) {
    line-height: 40px;
  }
  @media (min-width: 3840px) {
    height: 70px;
    font-size: 32px;
  }
`

const BgSpan: any = styled(Flex)`
  background: ${props =>
    (terminalView as any).darkTheme.status[
      props?.title?.replace(' ', '_') ?? 'untracked_status'
    ] ?? terminalView.darkTheme.status.untracked_status};
  border-radius: 20px;
  padding: 4px 16px;
  justify-content: center;
  width: min-content;
  color: ${terminalView.darkTheme.textColor};
  @media (min-width: 3840px) {
    padding: 20px 40px;
    border-radius: 60px;
  }
`
const RouteTextContainer: any = styled(CustomColFullHeight)`
  width: 25vw;
  @media (min-width: 1920px) and (max-width: 3840px) {
    width: 180px;
  }
  @media (min-width: 3840px) {
    width: 400px;
  }
`

const ArrowContainer: any = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin: 0px 21px 0px 12px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  color: ${terminalView.darkTheme.textColor};
  @media (min-width: 1920px) and (max-width: 3840px) {
    line-height: 32px;
    font-size: 20px;
  }
  @media (min-width: 3840px) {
    margin: 0px 30px 0px 18px;
    line-height: 44px;
    font-weight: 600;
    font-size: 44px;
  }
`

export const modifiedColumns = (tableName: any, sampleColumns: any) => {
  return sampleColumns.map((item: any) => {
    const { key, label, formatter } = item
    switch (key) {
      case 'status':
        return {
          id: key,
          width: '140px',
          Header: <ColHeader title={label}>{label}</ColHeader>,
          Cell: ({ row: { original } }: any) => {
            return (
              <ColFullHeight>
                <CustomColFullHeight>
                  <BgSpan
                    variant="h6 ellipsis"
                    mb={1}
                    title={original.status.toLowerCase() ?? ''}
                  >
                    {original.status ?? '-'}
                  </BgSpan>
                </CustomColFullHeight>
              </ColFullHeight>
            )
          }
        }
      case 'route':
        return {
          id: key,
          width: '232px',
          Header: <ColHeader title={label}>{label}</ColHeader>,
          Cell: ({ row: { original } }: any) => {
            return (
              <ColFullHeight>
                <Flex>
                  <RouteTextContainer title={original.origin ?? '-'}>
                    {original.origin ?? '-'}
                  </RouteTextContainer>
                  <ArrowContainer>
                    <FaArrowRight />
                  </ArrowContainer>
                  <RouteTextContainer title={original.destination ?? '-'}>
                    {original.destination ?? '-'}
                  </RouteTextContainer>
                </Flex>
              </ColFullHeight>
            )
          }
        }
      default:
        return {
          id: item.key,
          width: '120px',
          Header: <ColHeader title={label}>{label}</ColHeader>,
          Cell: ({ row: { original } }: any) => {
            let value = getValueFromNestedKey(original, key)
            return formatter && formatters[formatter] ? (
              <ColFullHeight>
                <CustomColFullHeight
                  title={formatters[formatter](value) || '-'}
                >
                  {formatters[formatter](value) || '-'}
                </CustomColFullHeight>
              </ColFullHeight>
            ) : (
              (
                <ColFullHeight>
                  <CustomColFullHeight title={value}>
                    {value}
                  </CustomColFullHeight>
                </ColFullHeight>
              ) ?? '-'
            )
          }
        }
    }
  })
}
